var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region ReconciliationAttendance - Ctor 
    ns.ReconciliationAttendance = function ReconciliationAttendance(attendance, activityReconciliationID, calcSnacksOnlyForPresent) {
        this.attendance = attendance;
        this.calcSnacksOnlyForPresent = calcSnacksOnlyForPresent;
        this.activityReconciliationID = activityReconciliationID || null;
        this.calculateProperties(attendance, this.activityReconciliationID);
    }
    // #endregion

    // #region ReconciliationAttendance - Methods

    ns.ReconciliationAttendance.prototype.getReconciliationAttendanceDTO = function () {
        return this.attendance;
    }

    ns.ReconciliationAttendance.prototype.calculateProperties = function (attendance, activityReconciliationID) {
        this.activityID = attendance.activityID;
        this.studentID = attendance.studentID;
        this.activityScheduleID = attendance.activityScheduleID;
        this.studentFullName = attendance.studentFullName;
        this.date = attendance.date;
        this.noOfMinutes = attendance.noOfMinutes;

        if (!String.prototype.isNullOrWhitespace(attendance.notes)) {
            this.notes = attendance.notes;
        } else {
            this.notes = '';
        }

        this.reconciled = !!attendance.activityReconciliationID &&
            attendance.activityReconciliationID != activityReconciliationID;

        if (!String.prototype.isNullOrWhitespace(attendance.reservationNotes)) {
            if (!String.prototype.isNullOrWhitespace(this.notes)) {
                this.notes += ' ';
            }

            this.notes += attendance.reservationNotes;
        }

        if (!String.prototype.isNullOrWhitespace(attendance.scheduleNotes)) {
            if (!String.prototype.isNullOrWhitespace(this.notes)) {
                this.notes += ' ';
            }
            this.notes += attendance.scheduleNotes;
        }


        this.firstPeriod = !!attendance.firstPeriodStartDate
            ? moment(attendance.firstPeriodStartDate).format('HH:mm') + ' - ' + moment(attendance.firstPeriodEndDate).format('HH:mm')
            : '';

        this.secondPeriod = !!attendance.secondPeriodStartDate
            ? moment(attendance.secondPeriodStartDate).format('HH:mm') + ' - ' + moment(attendance.secondPeriodEndDate).format('HH:mm')
            : '';

        if (!attendance.firstPeriodRegistered && attendance.firstPeriodAttendanceStatusID == 1 && attendance.firstPeriodAttendanceTypeID == 0)
        {
            // Do not show first period
            this.firstSnack = '';
            this.lunch = '';
            this.firstPeriodAttendanceStatus = '';
            this.firstPeriodAttendanceType = '';
        } else {
            if (this.calcSnacksOnlyForPresent) {
                this.firstSnack = attendance.firstPeriodAttendanceStatusID === 0 && attendance.firstSnackReserved
                    ? '\u2713'
                    : '\u2718';
            } else {
                this.firstSnack = attendance.firstSnack ? '\u2713' : '\u2718';
            }
            this.lunch = attendance.lunch ? '\u2713' : '\u2718';
            this.firstPeriodAttendanceStatus = this.attendanceStatusToString(attendance.firstPeriodAttendanceStatusID);
            this.firstPeriodAttendanceType = this.attendanceTypeToString(attendance.firstPeriodAttendanceTypeID);
        }

        if (!attendance.secondPeriodRegistered && attendance.secondPeriodAttendanceStatusID == 1 && attendance.secondPeriodAttendanceTypeID == 0)
        {
            this.secondSnack = '';
            this.secondPeriodAttendanceStatus = '';
            this.secondPeriodAttendanceType = '';
        } else {
            if (this.calcSnacksOnlyForPresent) {
                this.secondSnack = attendance.secondPeriodAttendanceStatusID === 0 && attendance.secondSnackReserved
                    ? '\u2713'
                    : '\u2718';
            } else {
                this.secondSnack = attendance.secondSnack ? '\u2713' : '\u2718';
            }
            this.secondPeriodAttendanceStatus = this.attendanceStatusToString(attendance.secondPeriodAttendanceStatusID);
            this.secondPeriodAttendanceType = this.attendanceTypeToString(attendance.secondPeriodAttendanceTypeID);
        }
    }

    ns.ReconciliationAttendance.prototype.attendanceStatusToString = function (input) {
        switch (input) {
            case 0:
                return 'TXT_STATUS_PRESENT';
            case 1:
                return 'TXT_STATUS_NOT_PRESENT_NOT_EXCUSED';
            case 2:
                return 'TXT_STATUS_NOT_PRESENT_EXCUSED';
            case 3:
                return 'TXT_STATUS_NOT_PRESENT_EXCUSED_NO_COMPENSATION';
            case 4:
                return 'TXT_STATUS_NOT_PRESENT_EXCUSED_NO_FOOD';
        }
    }

    ns.ReconciliationAttendance.prototype.attendanceTypeToString = function (input) {
        switch (input) {
            case 0:
                return 'TXT_VAL_REGISTERED';
            case 1:
                return 'TXT_VAL_ONEOFF';
            case 2:
                return 'TXT_VAL_AMEND';
            case 3:
                return 'TAX_VAL_PREVIEW';
        }
    }
    // #endregion

}(webooker_acivity_models));